<template>
  <div id="modul-belajar-from">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>
        <router-link :to="{path: '/modul-belajar'}">Modul Belajar</router-link>
      </li>
      <li class="active">Form</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Buat Tryout Baru</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Buat Modul Belajar</h4>
          </div>
          <div class="panel-body">
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('title') >= 0 }">
                  <label class="col-md-2 control-label">Judul *</label>
                  <div class="col-md-8 col-xs-12">
                    <span class="help-block" v-if="errors.indexOf('title') != -1">field ini wajib diisi</span>
                    <input type="text" v-model="title" class="form-control" placeholder="Judul / nama modul" required>
                  </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('join_code') >= 0 }">
                  <label class="col-md-2 control-label">Join Code *</label>
                  <div class="col-md-8 col-xs-12">
                    <span class="help-block" v-if="errors.indexOf('join_code') != -1">field ini wajib diisi</span>
                    <div class="input-group">
                      <input type="text" v-model="joinCode" class="form-control" placeholder="Generate / Ketik kode join sendiri" required>
                      <div class="input-group-btn">
                        <button class="btn btn-inverse" @click="joinCode = generateRandomCode(6)">Generate</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Deskripsi</label>
                  <div class="col-md-8 col-xs-12">
                      <input type="text" v-model="description" class="form-control" placeholder="Deksripsi modul" required>
                  </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('picture') != -1 }">
                  <label class="col-md-2 control-label">Picture *</label>
                  <div class="col-md-8 col-xs-12">
                    <span class="help-block" v-if="errors.indexOf('picture') != -1">field ini wajib diisi</span>
                    <div class="row">
                      <div class="col-md-2"><file-upload context="modul_belajar" v-on:uploaded="picture = $event"></file-upload></div>
                      <div class="col-md-10"><img v-if="picture != null" :src="picture" class="rounded-corner height-100 width-100"></div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <hr>
            <div class="pull-right">
              <button type="button" class="btn btn-success" @click="onSubmitBtnClicked()">Simpan</button>
              <ul class="nav navbar-nav navbar-right m-1">
                <li class="dropdown navbar-user dropleft">
                  <button href="javascript:;" class="btn btn-inverse" data-toggle="dropdown">
                    Kelola
                    <span class="hidden-xs"></span> <b class="caret"></b>
                  </button>
                  <ul class="dropdown-menu animated fadeInLeft">
                    <li class="arrow"></li>
                    <li><a href="javascript:;" @click="onManageMaterialBtnClicked()">Kelola Materi</a></li>
                    <li class="divider"></li>
                    <li><a href="javascript:;" @click="onManageLiveStreamBtnClicked()">Live Streaming</a></li>
                  </ul>
                </li>
              </ul>
              <!-- <button v-if="$route.query.id" type="button" class="btn btn-inverse" @click="onManageMaterialBtnClicked()">Kelola Materi</button> -->
              <!-- <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Kelola
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="#" @click="onManageMaterialBtnClicked()">Kelola Materi</a>
                  <a class="dropdown-item" href="#" @click="onManageLiveStreamBtnClicked()">Live Streaming</a>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import FileUpload from '@/components/plugins/FileUpload'
import Spinner from '@/components/plugins/Spinner'
import ItembankService from '@/services/itembank.js'

export default {
  name: 'modul-belajar-form',
  components: {
    'file-upload': FileUpload,
    'app-spinner': Spinner
  },
  data: function () {
    return {
      title: '',
      description: '',
      joinCode: '',
      picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_english.png',
      isLoading: false,
      errors: []
    }
  },
  methods: {
    generateRandomCode: function (length) {
      var code = ''
      var possibleChar = 'abcdefghijklmnopqrstuvwxyz1234567890'
      for (var i=0; i < length; i++) {
        code += possibleChar.charAt(Math.floor(Math.random() * possibleChar.length))
      }

      return code.toUpperCase()
    },
    onSubmitBtnClicked: function () {
      if (this.validateForm()) {
        var data = {
          join_code: this.joinCode,
          name: this.title,
          picture: this.picture,
          description: this.description
        }

        this.isLoading = true
        var context = this
        if (this.$route.query.id) {
          var modulId = this.$route.query.id
          ItembankService.updateModulBelajar(modulId, data, function (response) {
            context.isLoading = false
            if (response.success) {
              alert("Modul berhasil di update")
            }
          })
        } else {
          ItembankService.createModulBelajar(data, function (response) {
          context.isLoading = false
          if (response.success) {
              context.$router.push({path: '/modul-belajar'})
            }
          })
        }
      }
    },
    onManageMaterialBtnClicked: function () {
      var modulId = this.$route.query.id
      this.$router.push({path: '/modul-belajar/materials', query: {modul_id: modulId}})
    },
    onManageLiveStreamBtnClicked: function () {
      var modulId = this.$route.query.id
      this.$router.push({path: '/modul-belajar/live-stream', query: {modul_id: modulId}})
    },
    validateForm: function () {
      this.errors = []
      if (!this.title) this.errors.push('title')
      if (!this.joinCode) this.errors.push('join_code')
      if (!this.picture) this.errors.push('picture')

      return this.errors.length == 0
    }
  },
  mounted: function () {
    if (this.$route.query.id) {
      this.isLoading = true
      var modulId = this.$route.query.id
      var context = this
      ItembankService.getModulBelajar(modulId, function (response) {
        context.isLoading = false
        if (response.success) {
          context.title = response.data.name
          context.description = response.data.description
          context.joinCode = response.data.join_code
          context.picture = response.data.picture
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?a9f16c1e